/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "../../../../components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "../../../../examples/Navbars/DefaultNavbar";
import PageLayout from "../../../../examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "../Footer";
import { Box, Stack } from "@mui/material";
import Header from "../../../generalLayout/components/Header";

function BasicLayout({ image, children, is4Auth = false, ref = null }) {
  return (
    <PageLayout ref={ref} is4Auth={is4Auth}>

      {
        (!is4Auth)

        &&

        <DefaultNavbar
          action={{
            type: "external",
            route: "https://creative-tim.com/product/material-dashboard-react",
            label: "free download",
            color: "dark",
          }}
        />
      }
      {/* <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflowY: (is4Auth ? "hidden !important": "auto")
        }}

      /> */}
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transform: 'translate(-50%, -50%)',
          // zIndex: 0,
        }}
      >
        <source src="/videos/authBG.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </Box>
      <MDBox sx={{ overflowY: (is4Auth ? "hidden !important" : "auto"), display: 'flex' }} p={1} width="100%" height="100vh" mx="auto" zIndex="10000" position="relative" >
        <Stack
          alignItems="center"
          justifyContent="space-around"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <Stack
            alignItems="center"
            sx={{
              width: '100%',
              height: '100%',
              maxWidth: '880px !important',
              position: 'relative'
            }}
          >
            {children}
          </Stack>
        </Stack>
      </MDBox>
      <Footer light />
    </PageLayout>
  );
}

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  is4Auth: PropTypes.bool,
  ref: PropTypes.any
};

export default BasicLayout;
